import React from 'react';
// Images
import MainImage1 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-about-me.webp';
import MainImage2 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-black-tshirt.webp';
import MainImage3 from '../../assets/images/main/queen-blaire-dominatrix-and-prodomme-beauty-queen.webp';
// Constants
import { CompanyName, TRIBUTE_AMOUNT } from '../../utils/constants/Constants';
// Components
import CallToActionOne from '../cta/CallToActionOne';
import WhatIOfferComponent from '../general/WhatIOfferComponent';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';

function AboutPageMainContainer() {
  return (
    <main role='main' className='pt-16'>
      {/* Bio Section */}
      <section className='grid mb-20'>
        <div className='grid lg:grid-cols-[1fr_2fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-8 sm:px-10 xl:gap-x-10 md:px-16 lg:px-10'>
          {/* Image */}
          <div className='my-auto'>
            <img
              src={MainImage1}
              alt={`${CompanyName}`}
              className='mx-auto object-cover md:max-h-[60vh] rounded neon_shadow'
              loading='lazy'
            />
          </div>

          {/* Artcile */}
          <article className='grid gap-4 pt-2'>
            {/* Header */}
            <section className='grid grid-cols-reg w-full gap-x-6 pt-4'>
              <div className='grid items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest text-colour8'>
                  About Me
                </h3>
              </div>
              <div className='grid items-center'>
                <div
                  className='h-[2px] -mt-4 bg-colour8'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>
            {/* Main article */}
            <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                Sensual, sophisticated, yet undeniably strict—I am a commanding
                presence in the world of domination. With an air of refinement
                and an irresistible allure, I embody both elegance and a
                seductive edge. My control is effortless, My authority absolute,
                and My pleasure derives from the unwavering submission of those
                who kneel before Me.
              </p>

              <p>
                When addressing Me, remember this well — I take pleasure in
                being called
                <strong>
                  {' '}
                  Queen, Goddess, Mommy, Empress, Sir, Daddy, or Master
                </strong>
                . These titles reflect My strength, authority, and power.
                <strong> I do not respond to “Princess” or “Mistress”</strong> —
                such names have no place in My world.
              </p>

              <p>
                For Me, dominance is not a performance—it is an intrinsic part
                of My very being. A natural-born leader, I have been mastering
                the art of control, shaping men to My will with a mere glance or
                a whispered command. The power exchange in BDSM is more than an
                indulgence; it is My domain, where I thrive in bending minds and
                bodies to My desires.
              </p>

              <p>
                It amuses Me how easily men succumb to My presence—the shift in
                energy, the loss of control, the way their thoughts surrender
                the moment they kneel before Me. There is no need for pretense
                or exaggerated authority; My dominance is authentic, a force
                that draws out a submissive’s deepest cravings and compels them
                to obey.
              </p>

              <p>
                Whether you seek a{' '}
                <strong>sensory-rich fetish experience</strong> or a{' '}
                <strong>strict and immersive domination session</strong>, I
                tailor every encounter to My own satisfaction—while allowing My
                subjects to revel in the privilege of serving Me. Playful yet
                assertive, seductive yet merciless, I deliver an experience
                unlike any other.
              </p>
            </section>
          </article>
        </div>
      </section>

      {/* Dom Section */}
      <section className='grid mb-20'>
        <div className='grid lg:grid-cols-[2fr_1fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-8 sm:px-10 xl:gap-x-10 md:px-16 lg:px-10'>
          {/* Artcile */}
          <article className='grid gap-4 pt-2'>
            {/* Header */}
            <section className='grid grid-cols-reg w-full gap-x-6'>
              {/* Large screen */}
              <div className='hidden md:grid items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest text-colour8'>
                  My Life As A Domme
                </h3>
              </div>
              {/* Phone screen */}
              <div className='grid md:hidden items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest text-colour8'>
                  My Life As <br /> A Domme
                </h3>
              </div>
              <div className='grid items-center'>
                <div
                  className='h-[2px] -mt-4 bg-colour8'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            {/* Main article */}
            <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                I am <strong>Queen Blaire</strong>—confident, seductive, and
                fully in control. I don’t just enjoy power—I *embody* it. I was
                born to be served, worshipped, and obeyed. If you’re a
                submissive man, you’re already exactly where you belong—beneath
                Me.
              </p>

              <p>
                I’ve created <strong>exclusive fansites</strong> filled with
                sensual, dominant content for those who crave a taste of My
                world. Every clip, photo, and post is an invitation to indulge
                in My superiority—on *My* terms. Visit them. Watch. Obsess.
              </p>

              <p>
                Submission begins with a{' '}
                <strong>${TRIBUTE_AMOUNT} tribute</strong>. That’s your first
                test. Your first act of devotion. If you hesitate, you’re not
                ready. If you obey—good boy. Maybe I’ll let you serve Me
                further.
              </p>

              <p>
                I offer{' '}
                <strong>
                  custom clips, video calls, and real-time meetings
                </strong>{' '}
                for the few who prove themselves worthy. I do not chase. If you
                earn the privilege, you’ll experience what true control really
                feels like.
              </p>

              <p>
                Whether you're serving from afar or kneeling at My feet, know
                this: everything you do is for *My* pleasure. Follow
                instructions, show your loyalty, and perhaps I’ll allow you
                deeper into My world.
              </p>

              <p>
                <em>This isn’t a game. It’s a lifestyle.</em>
              </p>
            </section>
          </article>

          {/* Image */}
          <div className='my-auto pt-2'>
            <img
              src={MainImage2}
              alt={`${CompanyName} with her ass looking perfect`}
              className='mx-auto object-cover md:max-h-[60vh] rounded neon_shadow'
              loading='lazy'
            />
          </div>
        </div>
      </section>

      {/* Personal (No Kink) Section */}
      <section className='grid mb-20'>
        <div className='grid lg:grid-cols-[1fr_2fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-8 sm:px-10 xl:gap-x-10 md:px-16 lg:px-10'>
          {/* Image */}
          <div className='my-auto'>
            <img
              src={MainImage3}
              alt={`${CompanyName}`}
              className='mx-auto object-cover md:max-h-[60vh] rounded neon_shadow'
              loading='lazy'
            />
          </div>

          {/* Article */}
          <article className='grid gap-4 pt-2'>
            {/* Header */}
            <section className='grid grid-cols-reg w-full gap-x-6'>
              <div className='grid items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest text-colour8'>
                  Get To Know Queen Blaire
                </h3>
              </div>
              <div className='grid items-center'>
                <div
                  className='h-[2px] -mt-4 bg-colour8'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            {/* Main article */}
            <section className='grid h-full gap-2 text-center lg:text-left text-sm'>
              <p>
                Outside of kink, I enjoy lots of different hobbies. I’m an
                outdoor enthusiast. I try My best to find time every today to
                spend in nature whether that’s a hike/backpacking or just a walk
                with My doggo. I love camping, paddle boarding, wake surfing and
                riding My bike. When I’m not outside, I love to color/paint,
                play card games, have naked dance parties, read and play animal
                crossing on My switch.
              </p>
              <p>
                I’ve been learning new recipes and making protein dense meals to
                feed the muscles. I have a dairy allergy so I eat a lot of
                soups, tacos, pasta and sushi. I collect shark teeth, crystals,
                shells and pretty rocks from places I visit.
              </p>
              <p>
                My favorite kinds of movies are comedy and horror. My go to
                coffee order is a dirty chai latte with oatmilk. I’m a goofy gal
                who loves making people laugh. I’m an Aquarius ♒️ I’ve never
                been to the east coast but would love to change that in the next
                couple years. I love rainy days and the fall season so I can
                cozy up with a soft blanket.
              </p>
            </section>
          </article>
        </div>
      </section>

      <div className='mt-12'>
        <CallToActionOne />
      </div>


      {/* Social cta */}
      <div className='pt-8'>
        <SocialMediaCtaComponent />
      </div>
    </main>
  );
}

export default AboutPageMainContainer;
